import React, { FC } from 'react'
import WelcomeLayout from '../../components/WelcomeLayout/WelcomeLayout'
import Error401 from '../../components/Error/Error401'

const NotAuthorized: FC = () => {
	return (
		<WelcomeLayout>
			<Error401 />
		</WelcomeLayout>
	)
}

export default NotAuthorized
